var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPayment = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 269.996,
    viewBox: "0 0 270 269.996",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment_payment_terminal_smartphone_wireless_contactless_payment_wireless_payment",
    "data-name": "payment, payment terminal, smartphone, wireless, contactless payment, wireless payment",
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2170",
    "data-name": "Rectangle 2170",
    className: "cls-1",
    width: 16.875,
    height: 16.875,
    transform: "translate(91.563 218.122)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2171",
    "data-name": "Rectangle 2171",
    className: "cls-1",
    width: 16.875,
    height: 16.875,
    transform: "translate(66.251 218.122)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2172",
    "data-name": "Rectangle 2172",
    className: "cls-1",
    width: 16.875,
    height: 16.875,
    transform: "translate(116.876 218.122)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2173",
    "data-name": "Rectangle 2173",
    className: "cls-1",
    width: 16.875,
    height: 16.875,
    transform: "translate(91.563 184.372)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2174",
    "data-name": "Rectangle 2174",
    className: "cls-1",
    width: 16.875,
    height: 16.875,
    transform: "translate(66.251 184.372)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2175",
    "data-name": "Rectangle 2175",
    className: "cls-1",
    width: 16.875,
    height: 16.875,
    transform: "translate(116.876 184.372)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2176",
    "data-name": "Rectangle 2176",
    className: "cls-1",
    width: 16.875,
    height: 16.875,
    transform: "translate(91.563 150.626)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2177",
    "data-name": "Rectangle 2177",
    className: "cls-1",
    width: 16.875,
    height: 16.875,
    transform: "translate(66.251 150.626)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2178",
    "data-name": "Rectangle 2178",
    className: "cls-1",
    width: 16.875,
    height: 16.875,
    transform: "translate(116.876 150.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13555",
    "data-name": "Path 13555",
    className: "cls-1",
    d: "M279.237,234.205l-34.945-130.4a22.562,22.562,0,0,0-27.553-15.913L190,95.058V21.25A11.285,11.285,0,0,0,178.746,10H21.249A11.283,11.283,0,0,0,10,21.25v112.5a110.5,110.5,0,0,0,2.73,22.17L41.02,269.086A15.2,15.2,0,0,0,55,279.994h90a15.187,15.187,0,0,0,13.972-10.908l6.352-25.377,5.251,19.609a22.557,22.557,0,0,0,27.553,15.91l65.2-17.469A22.565,22.565,0,0,0,279.237,234.205ZM133.751,49.374h-67.5A16.925,16.925,0,0,0,49.376,66.249v50.625a16.925,16.925,0,0,0,16.875,16.875h67.5a15.735,15.735,0,0,0,2.042-.209l17.533,65.411L138.682,257.5H61.317L34.56,150.458A88.883,88.883,0,0,1,32.5,133.745V32.5h135v68.587l-15.97,4.28c-.311.081-.594.246-.9.348V66.249A16.922,16.922,0,0,0,133.751,49.374Zm-5.626,22.5v39.376H71.874V71.871ZM192.307,257.5,157.369,127.1l65.191-17.469,34.935,130.389Z",
    transform: "translate(0 0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13556",
    "data-name": "Path 13556",
    className: "cls-1",
    d: "M90.743,79.308a11.255,11.255,0,1,1-13.787-7.955A11.258,11.258,0,0,1,90.743,79.308Z",
    transform: "translate(139.212 144.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13557",
    "data-name": "Path 13557",
    className: "cls-1",
    d: "M109.79,38.125A28.12,28.12,0,0,1,81.666,10H109.79Z",
    transform: "translate(170.206 0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13558",
    "data-name": "Path 13558",
    className: "cls-1",
    d: "M70,10a67.5,67.5,0,0,0,67.5,67.5V55a45,45,0,0,1-45-45Z",
    transform: "translate(142.497 0)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPayment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/payment.b62edf97.svg";
export { ForwardRef as ReactComponent };